import './styles.scss';
const SkeletonLoaderItem = ({ style, className, width, height, maxWidth }) => {
	return <div className={`seleton_loader_item ${className || ''}`} style={{ width, height, maxWidth, ...style }}></div>;
};

export default SkeletonLoaderItem;
